
export function isVoid(value) {
  if (value === null || value === undefined) {
    return true
  }
  return false
}

export function isNumber(value) {
  if (isVoid(value)) {
    return false
  }
  return !isNaN(parseFloat(value))
}

export function parseValidRatio(v, suffix = '%') {
  if (!isNumber(v)) {
    return '--'
  }
  return `${v.toFixed(2)}${suffix}`
}

export function valueColorFormat(v) {
  if (!isNumber(v)) return 'light'
  else if (v >= 0) return 'positive-gradient'
  else if (v < 0) return 'negative-gradient'
}

export function probabilityColorFormat(v) {
  if (!isNumber(v)) return 'light'
  else if (v >= 50) return 'positive-gradient'
  else if (v < 50) return 'negative-gradient'
}
